// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ constants
const { CURSOR_LINE_COLOR } = require('constants/RAConstants/RAObjectiveTracking');

class CustomizedCursorLine extends React.Component {
    render() {
        const { points } = this.props;
        const x1 = points && points[0].x;
        const x2 = points && points[1].x;
        const y1 = points && points[0].y;
        const y2 = points && points[1].y;

        return (
            <g>
                <defs>
                    <marker
                        id="arrow"
                        markerWidth="20"
                        markerHeight="20"
                        refX="0"
                        refY="3"
                        orient="-90deg"
                        markerUnits="strokeWidth"
                        viewBox="0 0 20 20"
                    >
                        <path d="M0,0 L0,6 L9,3 z" fill={CURSOR_LINE_COLOR} />
                    </marker>
                </defs>
                <line
                    x1={x1}
                    y1={y1}
                    x2={x2}
                    y2={y2}
                    stroke={CURSOR_LINE_COLOR}
                    strokeWidth={1}
                    strokeDasharray={2}
                    markerEnd="url(#arrow)"
                />
            </g>
        );
    }
}

CustomizedCursorLine.propTypes = {
    points: PropTypes.array,
};

module.exports = CustomizedCursorLine;
